jQuery(function($){
    ////////////////////
    // フェードイン
    ////////////////////
    $(window).on('load scroll', function (){
        var box = $('.fadeIn');
        var animated = 'animated';
        box.each(function(){
            var boxOffset = $(this).offset().top;
            var scrollPos = $(window).scrollTop();
            var wh = $(window).height();
            if(scrollPos > boxOffset - wh + 100 ){
                $(this).addClass(animated);
            }
        });
    });

    ////////////////////
    // ページトップ
    ////////////////////
    var topBtn = $('.pageTop');
    topBtn.click(function () {
        $('body,html').animate({
            scrollTop: 0
        }, 300, 'swing');
        return false;
    });

    ////////////////////
    // 翻訳テキスト変更
    ////////////////////
    $(document).ready(function(){
        $(".footer-translateWrap a").eq(0).text("English");
        $(".footer-translateWrap a").eq(1).text("日本語");
    });

    ////////////////////
    // ヘッダーをスクロールで固定
    ////////////////////
    $(window).scroll(function () {
        if($(window).scrollTop() > 110) {
            $('.header').addClass('fixed');
        } else {
            $('.header').removeClass('fixed');
        }
    });

    ////////////////////
    // ハンバーガー
    ////////////////////
    $('.hamBtn').on('click', function() {
        $('.ham').toggleClass('active');
        $("html").toggleClass("active"); // 背景スクロール禁止
        $(this).toggleClass("active");
        $(".translateWrap").toggleClass("active");
    });

    ////////////////////
    // ハンバーガー 採用のアコーディオン
    ////////////////////
    $('.hamListWrap-subMenu .icon-plus').on('click', function(event) {
        $(this).toggleClass('open');
        $(this).closest('.hamListWrap-subMenu').find('.jsOpen').toggleClass('open');
    });

    ////////////////////
    // ニュース記事アコーディオン
    ////////////////////
    $('.newsOpen').on('click', function() {
        $(this).closest('.newsArticle').toggleClass('open');
        $(this).next('.contents').slideToggle();
    });

    ////////////////////
    // カテゴリーをセレクトボックスに
    ////////////////////
    var currentCatLinkText = $('.pageSideLinks._sp .current-cat > a').text();
    if (currentCatLinkText) {
        var $pTag = $('<span class="selectTxt">').text(currentCatLinkText);
        $('.pageSideLinks._sp ul').before($pTag);
    }
    $('.pageSideLinks._sp .selectTxt').on('click', function() {
        $(this).closest('.pageSideLinks').toggleClass('open');
        $(this).next('ul').slideToggle();
    });

     ////////////////////
    // タブのタームをセレクトボックスに
    ////////////////////
    var currentCatLinkText2 = $('.tabLinks .current-cat > a').text();
    if (currentCatLinkText2) {
        var $pTag2 = $('<span class="selectTxt">').text(currentCatLinkText2);
        $('.tabLinks ul').before($pTag2);
    }
    $('.tabLinks .selectTxt').on('click', function() {
        $(this).closest('.tabLinks').toggleClass('open');
        $(this).next('ul').slideToggle();
    });
    $(window).bind("load", function(){
        if (document.URL.match(/\/recruit/)) {
            $('.headerNav').addClass('recruitColor');
            $('body').addClass('recruitColor');
        }
    });

    ////////////////////
    // 募集要項アコーディオン
    ////////////////////
    $('.main._requirements .listWrap-item h2').on('click', function() {
        $(this).closest('.listWrap-item').toggleClass('open');
        $(this).next('.accordionContents').slideToggle(800);
    });

    ////////////////////
    // ページ内リンクにブラウザバックの機能をもたせない（URLを変更させない）+スムーススクロール
    ////////////////////
    function scrollToTarget(className, targetId) {
        $(className).click(function() {
            var target = $(targetId);
            if (target.length) {
                var position = target.offset().top;
                $('html, body').animate({ scrollTop: position }, 400);
                return false;
            }
        });
    }
    scrollToTarget(".main-office", "#main-office");
    scrollToTarget(".tokyo", "#tokyo");
    scrollToTarget(".fukuoka", "#fukuoka");
    scrollToTarget(".tawaramoto", "#tawaramoto");
    scrollToTarget(".yamato", "#yamato");
    scrollToTarget(".taiwan", "#taiwan");
    scrollToTarget(".hong-kong", "#hong-kong");
    scrollToTarget(".korea", "#korea");
    scrollToTarget(".shanghai", "#shanghai");
    scrollToTarget(".toukanshi", "#toukanshi");


    ////////////////////
    // tableでtrの中にtdが３つ以上ある場合、tableタグにクラスを付与
    ////////////////////
    $('.main._columnSingle table').each(function() {
        $(this).find('tr').each(function() {
            if ($(this).find('td').length >= 3) {
                $(this).closest('table').addClass('multiple');
                return false; // 一度クラスを追加したら、ループを抜ける
            }
        });
    });

    ////////////////////
    // スマホでスライドのパララックス方向を切り替える
    ////////////////////
    function adjustParallaxDirection() {
        var isMobile = $(window).width() <= 919;
        $('.mv-left .swiper-slide div').each(function() {
            if (isMobile) {
                $(this).attr('data-swiper-parallax-x', $(this).attr('data-swiper-parallax-y')).removeAttr('data-swiper-parallax-y');
            } else {
                $(this).attr('data-swiper-parallax-y', $(this).attr('data-swiper-parallax-x')).removeAttr('data-swiper-parallax-x');
            }
        });
        $('.mv-right .swiper-slide div').each(function() {
            if (isMobile) {
                $(this).attr('data-swiper-parallax-x', $(this).attr('data-swiper-parallax-y')).removeAttr('data-swiper-parallax-y');
            } else {
                $(this).attr('data-swiper-parallax-y', $(this).attr('data-swiper-parallax-x')).removeAttr('data-swiper-parallax-x');
            }
        });
        // Swiperインスタンスを更新
        //mvSwiperLeft.update();
        //mvSwiperRight.update();
    }
    // 初期ロード時にパララックス属性を調整
    adjustParallaxDirection();
    // 画面サイズが変更された時に再度調整
    $(window).resize(adjustParallaxDirection);
})


////////////////////
// 追従ボタンのフェードイン
////////////////////
document.addEventListener('DOMContentLoaded', function() {
    function checkVisibility() {
        var scrollPos = window.scrollY || window.scrollTop || document.getElementsByTagName("html")[0].scrollTop;
        var windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        var footerTop = document.querySelector('footer').getBoundingClientRect().top + window.scrollY;
        var button = document.querySelector('.btnOnline');
        if (button) {
            if (scrollPos > 100 && (scrollPos + windowHeight) < footerTop) {
                button.classList.add('active');
            } else {
                button.classList.remove('active');
            }
        }
    }
    checkVisibility();
    window.addEventListener('scroll', checkVisibility);
    window.addEventListener('resize', checkVisibility);
});

////////////////////
// スクロール位置に合わせてクラス名付け替え
////////////////////
document.addEventListener('DOMContentLoaded', function() {
    const navLinks = document.querySelectorAll('.pageSideLinks._scrollMarker li');
    const sections = document.querySelectorAll('.linkContents');

    // スクロール時の処理
    function onScroll() {
        let currentIndex = 0;
        sections.forEach((section, index) => {
            const rect = section.getBoundingClientRect();
            if (rect.top <= 200 && rect.bottom > 200) {
                currentIndex = index;
            }
        });
        navLinks.forEach((link, index) => {
            if (index === currentIndex) {
                link.classList.add('current');
            } else {
                link.classList.remove('current');
            }
        });
    }
    window.addEventListener('scroll', onScroll);
    onScroll(); // 初期表示時にも実行しておく
});